import { APP_CERTIFICATION_CREDENTIAL_ID } from '../constants/Certification';

/**
 * @deprecated Please use the new `certified` boolean field instead.
 */
export function getHasAppCertificationCredential(credentials) {
  return credentials.includes(APP_CERTIFICATION_CREDENTIAL_ID);
}